module.exports = __webpack_public_path__ + "media/human_3.e7853732.mp3";